import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <h3 className="text-lg font-heading font-bold mb-3">VigorBuy Spreadsheet Hub</h3>
            <p className="text-sm text-white/60 leading-relaxed max-w-md mb-4">
              The most complete Vigorbuy Spreadsheet information platform. Organizing thousands of product links with category guides, quality references, and shopping resources — all in one centralized database.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-1.5 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-full text-sm text-white transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
                Vigorbuy Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-1.5 px-4 py-2 bg-accent-500 hover:bg-accent-600 rounded-full text-sm text-white transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shopping-cart-line w-4 h-4 flex items-center justify-center"></i>
                Buy It Now
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">Guides</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer">Home</Link></li>
              <li><Link to="/article/vigorbuy-spreadsheet-complete-guide" className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer">Shopping Guide</Link></li>
              <li><Link to="/article/vigorbuy-spreadsheet-safety-guide" className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer">Safety Guide</Link></li>
              <li><Link to="/article/vigorbuy-spreadsheet-beginners-guide" className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer">Beginners Guide</Link></li>
              <li><Link to="/article/vigorbuy-spreadsheet-product-research" className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer">Product Research</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer">Shoes Category</a></li>
              <li><a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer">Hoodies / Sweaters</a></li>
              <li><a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer">Accessories</a></li>
              <li><a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer">Bags</a></li>
              <li><a href="https://kaspreadsheet.com/search-923/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer">Perfumes</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} Vigorbuy Spreadsheet Hub. An independent informational resource. Not affiliated with any third-party platform.
          </p>
          <p className="text-xs text-white/40">
            All external links open in new tabs. We organize product information but do not process transactions.
          </p>
        </div>
      </div>
    </footer>
  );
}